import { render } from "./RulesMain.vue?vue&type=template&id=49bff395"
import script from "./RulesMain.vue?vue&type=script&lang=js"
export * from "./RulesMain.vue?vue&type=script&lang=js"

import "./RulesMain.vue?vue&type=style&index=0&id=49bff395&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__